import api from "../../api";
import {promptData} from "../../util/MessageTools";
import {checkEnumToString, gameItemEnumToString, checkStringToEnum,gradeEnumToString} from '../../util/EnumTransition'

export default {
  name: "enterForCheck",
  data() {
    return {
      data: [],
      viewDetailDialog: false,//查看报名的详情
      userId: "",//这个是点击行的参赛选手的userId
      teacherData: [],
      memberData: [],
      teamName: "",
      gameItem: "生态过程",
      options: [{
        value: '1',
        label: '全部'
      }, {
        value: '2',
        label: '审核中'
      }, {
        value: '3',
        label: '审核通过'
      }, {
        value: '4',
        label: '审核失败'
      }/*,{
        value: '5',
        label: '未报名'
      }*/],
      educationList:[
        {
          value: 'NOT_APPLICABLE',
          label: '全部'
        }, {
          value: 'UNDERGRADE',
          label: '本科生'
        }, {
          value: 'MASTER',
          label: '研究生'
        },
      ],
      updateCheckStatusDisabled: false,//如果审核过之后,就不允许修改
      currentRow: {},//当前行信息
      // enterForStatus: '2',
      educationStatus: 'NOT_APPLICABLE',//学历筛选条件
      certificateReason: "",

    }
  },
  methods: {

    /**
     * 选择的值变化的时候
     * @param value
     */
    onchange(value) {
      // this.enterForStatus = value
      this.data = []
      let vue = this
      vue.tableLoading = true
      api.enterFor.getAllCertificateInfosOfBrief(value).then(function (response) {
        vue.tableLoading = false
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          vue.data = response.data.result
          vue.giveTableValue(vue.data)
        }
      }).catch(err=>{
        vue.tableLoading = false
      })
    },

    /**
     * 查看详细信息
     * @param row 当前行的信息
     */
    viewDetail(row) {
      this.currentRow = row
      this.teacherData = []
      this.memberData = []
      this.teamName = ""
      this.gameItem = ""
      let vue = this
      api.enterFor.getCertificateInfoByUserId(row.userId).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          vue.viewDetailDialog = true
          let result = response.data.result
          if(result.certificateReason==="" || result.certificateReason==null){
            vue.certificateReason = ""
          }else{
            vue.certificateReason = result.certificateReason
          }

          if (result.certificateStatus === "APPROVED" || result.certificateStatus ==="REFUSED") {
            vue.updateCheckStatusDisabled = true
          } else {
            vue.updateCheckStatusDisabled = false
          }
          vue.userId = result.userId
          vue.teamName = result.teamName
          vue.gameItem = gameItemEnumToString(result.gameItem)

          vue.memberData = []
          let obj = {}
          obj.memberRole = '队长'
          obj.memberName = result.leaderName //队长信息
          obj.idCardNo = result.leaderIdCardNo
          obj.phone = result.leaderPhone
          obj.email = result.leaderEmail
          obj.schoolName = result.leaderSchoolName
          obj.college = result.leaderCollege
          obj.grade = gradeEnumToString(result.leaderGrade)
          obj.fieldName = result.leaderFieldName
          vue.memberData.push(obj)
          if (result.memberInfos != null) {
            for (let i = 0; i < result.memberInfos.length; i++) {
              result.memberInfos[i].memberRole = '队员'
              result.memberInfos[i].grade = gradeEnumToString(result.memberInfos[i].grade)
              vue.memberData.push(result.memberInfos[i])
            }
          }
          vue.teacherData = result.teacherInfos
        }
      })
    },
    /**
     * 编辑团队信息
     * @param row
     */
    updateTeamMessage(row){
      this.$router.push({
        name: 'teamMessage',
        params: {
          userId: row.userId
        }
      })

    },


    /**
     * 修改审核状态
     * @param type 1同意 2拒绝
     */
    // updateCheckStatus(type) {
    //   let vue = this
    //   if (type === 1) {
    //     type = "APPROVED"
    //   } else {
    //     type = "REFUSED"
    //     if (vue.certificateReason === null || vue.certificateReason === "") {
    //       promptData("请填写拒绝原因!", this)
    //       return
    //     }
    //     if (vue.certificateReason.length > 200) {
    //       promptData("拒绝原因请少于两百字!", this)
    //       return
    //     }
    //   }
    //   api.enterFor.changeCertificateStatus(this.userId, type,vue.certificateReason).then(function (response) {
    //     if (response == null) {
    //       return null
    //     }
    //     if (response.data.code === "0") {
    //       vue.viewDetailDialog = false
    //       for (let i = 0; i < vue.data.length; i++) {
    //         if (vue.data[i].userId === vue.userId) {
    //           if (vue.enterForStatus !== "1") {
    //             vue.data.splice(i, 1)
    //           } else {
    //             if (type === "APPROVED") {
    //               vue.data[i].certificateStatus = "审核通过"
    //             } else {
    //               vue.data[i].certificateStatus = "审核失败"
    //             }
    //           }
    //           break
    //         }
    //       }
    //     }
    //   })
    // },

    /**
     * 给table赋值
     * @param result
     */
    giveTableValue(result) {
      let vue = this
      for (let i = 0; i < vue.data.length; i++) {
        vue.data[i].certificateStatus = checkEnumToString(vue.data[i].certificateStatus)
        vue.data[i].gameItem = gameItemEnumToString(vue.data[i].gameItem)

        let teacher = ""
        if (vue.data[i].teacherInfos.length === 1) {
          teacher = vue.data[i].teacherInfos[0].teacherName
        } else {
          teacher = vue.data[i].teacherInfos[0].teacherName + "," + vue.data[i].teacherInfos[1].teacherName
        }
        vue.data[i].teacherName = teacher
      }
    },
  },

  created() {
    let vue = this
    this.tableLoading = true
    api.enterFor.getAllCertificateInfosOfBrief(this.educationStatus).then(function (response) {
      vue.tableLoading = false
      if (response == null) {
        return null
      }
      if (response.data.code === "0") {
        vue.data = response.data.result
        vue.giveTableValue(vue.data)

      }
    }).catch(err=>{
      vue.tableLoading = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/EnterForCheck.js